import { FocusEvent } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import {
  ADDITIONAL_PROPERTY_FLAG,
  FormContextType,
  StrictRJSFSchema,
  TranslatableString,
  WrapIfAdditionalTemplateProps,
} from '@rjsf/utils';
import { removePillStyle } from './ArrayFieldItemTemplate.styles';

export default function WrapIfAdditionalTemplate<T, S extends StrictRJSFSchema, F extends FormContextType>(
  props: WrapIfAdditionalTemplateProps<T, S, F>,
) {
  const {
    children,
    classNames,
    style,
    disabled,
    id,
    label,
    onDropPropertyClick,
    onKeyChange,
    readonly,
    required,
    schema,
    registry,
  } = props;
  const { translateString } = registry;
  const keyLabel = translateString(TranslatableString.KeyLabel, [label]);
  const additional = ADDITIONAL_PROPERTY_FLAG in schema;

  if (!additional) {
    return (
      <div className={classNames} style={style}>
        {children}
      </div>
    );
  }

  const handleBlur = ({ target }: FocusEvent<HTMLInputElement>) => onKeyChange(target && target.value);

  return (
    <Grid container key={`${id}-key`} alignItems="center" spacing={2} className={classNames} style={style}>
      <Grid item xs>
        <TextField
          fullWidth
          required={required}
          label={keyLabel}
          defaultValue={label}
          disabled={disabled || readonly}
          id={`${id}-key`}
          name={`${id}-key`}
          onBlur={!readonly ? handleBlur : undefined}
          type="text"
        />
      </Grid>
      <Grid item xs>
        {children}
      </Grid>
      <Grid item>
        <Tooltip title="Remove">
          <span style={{ display: 'inline-flex' }}>
            <IconButton
              aria-label="remove"
              size="small"
              sx={removePillStyle}
              disabled={disabled || readonly}
              onClick={onDropPropertyClick(label)}
            >
              <RemoveIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
    </Grid>
  );
}
